import React from 'react';
import productos from '../../../utils/productos';
import '../../../features/catalogo/styles/ProductosDropdown.css';

const ProductosDropdown = ({
  visible,
  activeTab,
  setActiveTab,
  onSeleccionarProducto,
}) => {
  if (!visible) return null;

  const handleTabClick = tab => {
    setActiveTab(activeTab === tab ? null : tab);
  };

  const tabsOrdenados = [
    'Antibióticos',
    'Cardiometabólica',
    'Respiratoria',
    'Otros',
  ];

  return (
    <div className={`productos-dropdown ${visible ? 'visible' : 'hidden'}`}>
      <div className="productos-header-bar">
        <div className="productos-tabs">
          {tabsOrdenados.map(tab => (
            <button
              key={tab}
              className={`productos-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => handleTabClick(tab)}
              aria-expanded={activeTab === tab}
              aria-controls={`panel-${tab}`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {activeTab && (
        <div className="productos-contenido" id={`panel-${activeTab}`}>
          <div className="productos-lista">
            {productos[activeTab]?.map(({ alias, nombreCompleto }, index) => (
              <div
                key={index}
                className="producto-item"
                onClick={() => onSeleccionarProducto(nombreCompleto)}
              >
                <span className="producto-plus">+</span>
                <span className="producto-nombre">{alias}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(ProductosDropdown);
